import {useEffect} from "react"
import {useDispatch} from "react-redux"
import {breakpoints} from "@next/themes"
import {useMediaQuery} from "../useMediaQuery"
import {setCurrentBreakpointAction} from "../../ducks/search"

export const useSetBreakpoint = () => {
    const dispatch = useDispatch()
    const isXs = useMediaQuery(`(min-width: ${breakpoints.values.xs}px)`)
    const isSm = useMediaQuery(`(min-width: ${breakpoints.values.sm}px)`)
    const isMd = useMediaQuery(`(min-width: ${breakpoints.values.md}px)`)
    const isLg = useMediaQuery(`(min-width: ${breakpoints.values.lg}px)`)
    const isXl = useMediaQuery(`(min-width: ${breakpoints.values.xl}px)`)
    const isXXl = useMediaQuery(`(min-width: ${breakpoints.values.xxl}px)`)

    useEffect(() => {
        window.requestIdleCallback(() => {
            if (isXXl) dispatch(setCurrentBreakpointAction("xxl") as any)
            else if (isXl) dispatch(setCurrentBreakpointAction("xl") as any)
            else if (isLg) dispatch(setCurrentBreakpointAction("lg") as any)
            else if (isMd) dispatch(setCurrentBreakpointAction("md") as any)
            else if (isSm) dispatch(setCurrentBreakpointAction("sm") as any)
            else if (isXs) dispatch(setCurrentBreakpointAction("xs") as any)
        })
    })
}
